import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface PadesSignatureImageChoiceResult {
  useDefault: boolean;
  imageBase64?: string;
}

@Component({
  selector: 'app-pades-signature-image-choice-modal',
  templateUrl: './pades-signature-image-choice-modal.component.html',
  styleUrls: ['./pades-signature-image-choice-modal.component.css'],
  standalone: false
})
export class PadesSignatureImageChoiceModalComponent {
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  selectedFile: File | null = null;
  errorMessage: string | null = null;

  constructor(public dialogRef: MatDialogRef<PadesSignatureImageChoiceModalComponent>) {}

  cancel(): void {
    this.dialogRef.close();
  }

  useDefault(): void {
    this.dialogRef.close({ useDefault: true } as PadesSignatureImageChoiceResult);
  }

  triggerFileInput(): void {
    this.fileInputRef?.nativeElement?.click();
  }

  onFileSelected(event: Event): void {
    this.errorMessage = null;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      this.selectedFile = null;
      return;
    }
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') {
      this.errorMessage = 'Use una imagen PNG o JPG.';
      this.selectedFile = null;
      input.value = '';
      return;
    }
    this.selectedFile = file;
  }

  confirmUpload(): void {
    if (!this.selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const b64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
      if (b64) {
        this.dialogRef.close({ useDefault: false, imageBase64: b64 } as PadesSignatureImageChoiceResult);
      }
    };
    reader.onerror = () => {
      this.errorMessage = 'No se pudo leer el archivo.';
    };
    reader.readAsDataURL(this.selectedFile);
  }
}
